module.exports = __webpack_public_path__ + "img/logo.90f3ba77.png";